import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import { OwnProps } from './index';
import { selectSprayWorksheetProductsKeyedById } from '../../../../selectors';

const selectProductId = (state: AppState, props: OwnProps): ProductId =>
    props.productId;

const selectProductWaterRate = createDeepEqualSelector(
    selectSprayWorksheetProductsKeyedById,
    selectProductId,
    (productsKeyedById, productId) =>
        get(productsKeyedById, [productId, 'waterRate'])
);

const makeSelectProductWaterRate = (): typeof selectProductWaterRate =>
    selectProductWaterRate;

export { selectProductId, makeSelectProductWaterRate };
